import { firestoreDB } from "./config";
import { collection, doc, getDoc, query, where, getDocs, addDoc, getCountFromServer, setDoc } from "firebase/firestore";

export const checkUsernameAvailability = async username => {
    try {
        const usernamesRef = collection(firestoreDB, 'reserved_usernames');
        const q = query(usernamesRef, where('username', '==', username));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
            throw new Error('Custom: Error (custom/username-already-in-use)', { cause: { code: 'custom/username-already-in-use' }});
        }

        return true;
    } catch (error) {
        throw new Error(error.message, { cause: { ...error.cause }});
    }
};

export const isBetaUser = async userId => {
    if (!userId) return;

    try {
        const userRef = doc(firestoreDB, 'beta_users', userId);
        const userSnap = await getDoc(userRef);

        return userSnap.exists();
    } catch (error) {
        throw new Error(error.message, { cause: { ...error.cause }});
    }
};

export const storeUsername = async (userId, username) => {
    if (!userId || !username) return;

    const trimmedUsername = username.trim();

    try {
        // const usernameRef = doc(firestoreDB, 'reserved_usernames', userId);
        // await setDoc(usernameRef, { username });

        const q = query(
            collection(firestoreDB, 'reserved_usernames'),
            where('username', '==', trimmedUsername)
        );

        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
            const existingDoc = snapshot.docs[0];

            if (existingDoc.id !== userId) {
                throw new Error('Custom: Error (auth/username-already-in-use)');
            }
        }

        const usernameDocRef = doc(firestoreDB, 'reserved_usernames', userId);
        const usernameDocSnap = await getDoc(usernameDocRef);

        if (usernameDocSnap.exists()) {
            throw new Error('Custom: Error (auth/username-already-set)');
        }

        await setDoc(usernameDocRef, {
            username: trimmedUsername,
            createdAt: new Date()
        });

        return true;
    } catch (error) {
        throw new Error(error);
    }
};

export const storeBetaUser = async (userId, roleId, acknowledgements = []) => {
    if (!userId || !roleId || !acknowledgements?.length) return;

    // TODO: Validate all acknowledgements present.

    const user = {
        roleId,
        status: 'provisional',
        submittedAt: new Date(),
        acknowledgements: [...acknowledgements]
    }
    
    try {
        const userRef = doc(firestoreDB, 'beta_users', userId);
        await setDoc(userRef, { ...user });
    } catch (error) {
        throw new Error(error);
    }
};

export const getUserBetaRoleId = async userId => {
    if (!userId) return;

    try {
        const userRef = doc(firestoreDB, 'beta_users', userId);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
            throw new Error('User does not exist.');
        }

        return userSnap.data().roleId;
    } catch (error) {
        throw new Error(error);
    }
};

export const isEmailOnWaitList = async (email, roleId) => {
    if (!email || !roleId) return false;


    try {

        const waitListUsersRef = collection(firestoreDB, 'waitlist_users');

        const q = query(
            waitListUsersRef,
            where('email', '==', email),
            where('roleId', '==', roleId),
            where('status', 'in', ['waiting', 'invited'])
        );

        const querySnapshot = await getDocs(q);

        return !querySnapshot.empty;
    } catch (error) {
        throw new Error(error);
    }
};

export const storeWaitListUser = async (email, roleId) => {
    if (!email || !roleId) return;

    const trimmedEmail = email.trim().toLowerCase();

    try {
        const alreadyOnList = await isEmailOnWaitList(trimmedEmail, roleId);

        if (alreadyOnList) {
            throw new Error('Custom: Error (waitlist/already-joined)');
        }

        await addDoc(collection(firestoreDB, 'waitlist_users'), {
            email: trimmedEmail,
            roleId,
            status: 'waiting',
            joinedAt: new Date(),
            inviteExpiresAt: null
        });

        return true;
    } catch (error) {
        throw new Error(error);
    }
};

export const getWaitListCount = async roleId => {
    if (!roleId) return 0;

    try {
        const waitListRef = collection(firestoreDB, 'waitlist_users');
        const q = query(waitListRef, where('roleId', '==', roleId));
        const snapshot = await getCountFromServer(q);
        return snapshot.data().count;
    } catch (error) {
        throw new Error(error);
    }
};

export const getUsersCount = async () => {
    try {
        const usernamesRef = collection(firestoreDB, 'beta_users');
        const usernamesSnapshot = await getCountFromServer(usernamesRef);
        return usernamesSnapshot.data().count;
    } catch (error) {
        throw new Error(error);
    }
};

export const getRoleUsersCount = async roleId => {
    if (!roleId) return 0;

    try {
        const betaUsersRef = collection(firestoreDB, 'beta_users');
        const q = query(betaUsersRef, where('roleId', '==', roleId));
        const snapshot = await getCountFromServer(q);
        return snapshot.data().count;
    } catch (error) {
        throw new Error(error);
    }
};
